import ConstantHelper from "~helpers/ConstantHelper";

export const [organizationMemberFields, organizationMemberFieldsOptions, organizationMemberFieldsMap] =
  ConstantHelper.typify({
    STR: "constants.organizationMemberField.string",
    INT: "constants.organizationMemberField.integer",
    STR_ARR: "constants.organizationMemberField.stringArray",
    INT_ARR: "constants.organizationMemberField.integerArray",
    USER: "constants.organizationMemberField.user",
    DATE: "constants.organizationMemberField.date",
    EMAIL: "constants.organizationMemberField.email",
    FLOAT: "constants.organizationMemberField.float",
    PHONE_NUMBER: "constants.organizationMemberField.phoneNumber",
    BOOL: "constants.organizationMemberField.bool",
  });

export const organizationMemberVisibility = {
  MEMBER_ONLY: "MEMBER_ONLY",
  PROJECT_OWNER: "PROJECT_OWNER",
  AGENT: "AGENT",
  COMPANY: "COMPANY",
  PUBLIC: "PUBLIC",
};

export const [organizationComparisonTypes, organizationComparisonTypesOptions, organizationComparisonTypesMap] =
  ConstantHelper.typify({
    GTE: "constants.organizationComparisonTypes.gte",
    GT: "constants.organizationComparisonTypes.gt",
    LTE: "constants.organizationComparisonTypes.lte",
    LT: "constants.organizationComparisonTypes.lt",
    EQ: "constants.organizationComparisonTypes.eq",
    EXACT: "constants.organizationComparisonTypes.exact",
    STR_CONTAINS: "constants.organizationComparisonTypes.strContains",
    ICONTAINS: "constants.organizationComparisonTypes.iContains",
    ISTARTSWITH: "constants.organizationComparisonTypes.iStartsWith",
    STARTSWITH: "constants.organizationComparisonTypes.startsWith",
    ARRAY_CONTAINS: "constants.organizationComparisonTypes.arrayContains",
  });
export const organizationComparisonOptions = [
  // { label: "Exact", value: organizationComparisonTypes.EXACT },
  { label: "Equals", value: organizationComparisonTypes.EQ },
  { label: "Contains", value: organizationComparisonTypes.STR_CONTAINS },
  { label: "Contains [i]", value: organizationComparisonTypes.ICONTAINS },
  { label: "Starts with", value: organizationComparisonTypes.STARTSWITH },
  { label: "Starts with [i]", value: organizationComparisonTypes.ISTARTSWITH },
  { label: "Less Than", value: organizationComparisonTypes.LT },
  { label: "Less Than or Equal", value: organizationComparisonTypes.LTE },
  { label: "Greater Than", value: organizationComparisonTypes.GT },
  { label: "Greater Than or Equals", value: organizationComparisonTypes.GTE },
  { label: "Array Contains", value: organizationComparisonTypes.ARRAY_CONTAINS },
];

// export const organizationActionTypes = {
//   TELEGRAM: "TEL",
//   WHATSAPP: "WP",
//   TWILIO: "TWL",
//   SMS: "SMS",
//   EMAIL: "EMAIL",
//   PUSH_NOTIFICATION: "PUSH_NOTIFICATION",
// };

export const [organizationActionTypes, organizationActionTypesOptions, organizationActionTypesMap] =
  ConstantHelper.typify({
    EMAIL: "constants.organizationActionTypes.email",
    SMS: "constants.organizationActionTypes.sms",
    // TWL: "Twilio",
    WHATSAPP: "constants.organizationActionTypes.whatsapp",
    TELEGRAM: "constants.organizationActionTypes.telegram",
    PUSH_NOTIFICATION: "constants.organizationActionTypes.pushNotification",
  });

export const organizationResource = {
  INSIDE: "INSIDE",
  PUBLIC: "PUBLIC",
};

export const [organizationFilterType, organizationFilterTypeOptions, organizationFilterTypeMap] = ConstantHelper.typify(
  {
    AND: "constants.organizationFilterType.and",
    OR: "constants.organizationFilterType.or",
    COMPARISON: "constants.organizationFilterType.comparison",
  }
);

export const [organizationVisibilityType, organizationVisibilityTypeOptions, organizationVisibilityTypeMap] =
  ConstantHelper.typify({
    MEMBER_ONLY: "constants.organizationVisibility.memberOnly",
    PROJECT_OWNER: "constants.organizationVisibility.projectOwner",
    AGENT: "constants.organizationVisibility.agent",
    COMPANY: "constants.organizationVisibility.company",
    PUBLIC: "constants.organizationVisibility.public",
  });

export const [organizationQuestionType, organizationQuestionTypeOptions, organizationQuestionTypeMap] =
  ConstantHelper.typify({
    /** @type {"TEXT"} */
    TEXT: "constants.organizationQuestionType.text",
    /** @type {"RANGE"} */
    RANGE: "constants.organizationQuestionType.range",
    /** @type {"CHOICE"} */
    CHOICE: "constants.organizationQuestionType.choice",
  });

// export const organizationQuestionTypeMap = {
//   [organizationQuestionType.TEXT]: "Text",
//   [organizationQuestionType.RANGE]: "Range",
//   [organizationQuestionType.CHOICE]: "Choice",
// };

export const [organizationSurveyType, organizationSurveyTypeOptions, organizationSurveyTypeMap] = ConstantHelper.typify(
  {
    ANONYMOUS: "constants.organizationSurveyType.anonymous",
    PUBLIC: "constants.organizationSurveyType.public",
    IDENTIFIED: "constants.organizationSurveyType.identified",
  }
);

export const [organizationResourceType, organizationResourceTypeOptions, organizationResourceTypeMap] =
  ConstantHelper.typify({
    INSIDE: "constants.organizationResourceType.inside",
    PUBLIC: "constants.organizationResourceType.public",
  });

export const organizationDayOptions = [
  { label: "Monday", value: 0 },
  { label: "Tuesday", value: 1 },
  { label: "Wednesday", value: 2 },
  { label: "Thursday", value: 3 },
  { label: "Friday", value: 4 },
  { label: "Saturday", value: 5 },
  { label: "Sunday", value: 6 },
];

export const [
  organizationAnnouncementActionType,
  organizationAnnouncementActionTypeOptions,
  organizationAnnouncementActionTypeMap,
] = ConstantHelper.typify({
  TELEGRAM: "Telegram",
  WHATSAPP: "WhatsApp",
  TWILIO: "Twilio",
  SMS: "SMS",
  EMAIL: "Email",
  PUSH_NOTIFICATION: "Push Notification",
});

export const [
  organizationAnnouncementFilterType,
  organizationAnnouncementFilterTypeOptions,
  organizationAnnouncementFilterTypeMap,
] = ConstantHelper.typify({
  ID_LIST: "constants.organizationAnnouncementFilterType.idList",
  //"Customer List",
  LOW_CODE: "constants.organizationAnnouncementFilterType.lowCode",
  COMPARISON: "constants.organizationAnnouncementFilterType.comparison",
});

// export const [
//   organizationAnnouncementStatus,
//   organizationAnnouncementStatusOptions,
//   organizationAnnouncementStatusMap,
// ] = ConstantHelper.typify({
//   SCHEDULED: "Scheduled",
//   SENDING: "Sending",
//   PUBLISHED: "Published",
// });

export const [
  organizationAnnouncementStatus,
  organizationAnnouncementStatusOptions,
  organizationAnnouncementStatusMap,
] = ConstantHelper.typify({
  PROCESSING: "constants.organizationAnnouncementStatus.processing",
  DONE: "constants.organizationAnnouncementStatus.done",
  SCHEDULED: "constants.organizationAnnouncementStatus.scheduled", //cancel
  DRAFT: "constants.organizationAnnouncementStatus.draft", //cancel
  WAITING: "constants.organizationAnnouncementStatus.waiting", //cancel
});

export const [
  organizationAnnouncementPeriodicStatus,
  organizationAnnouncementPeriodicStatusOptions,
  organizationAnnouncementPeriodicStatusMap,
] = ConstantHelper.typify({
  ACTIVE: "Active",
  INACTIVE: "Inactive",
});

export const [
  organizationResourceAttendanceStatus,
  organizationResourceAttendanceStatusOptions,
  organizationResourceAttendanceStatusMap,
] = ConstantHelper.typify({
  no_info: "No Info",
  attended: "Attended",
  not_attended: "Not Attended",
});
